// extracted by mini-css-extract-plugin
export default {"Container":"StnVideoAd-module__Container__PzeQ3","TOP":"StnVideoAd-module__TOP__WuYR7","Spacer":"StnVideoAd-module__Spacer__MsQhM","Ad":"StnVideoAd-module__Ad__J5eOK"};